import React, { useState } from 'react';
import './Shop.css';
import { AiOutlineShoppingCart, AiOutlineSearch } from 'react-icons/ai';
import { BsFilter, BsStarFill, BsStarHalf, BsStar } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';

function Shop() {
  const navigate = useNavigate();
  
  // 検索状態
  const [searchTerm, setSearchTerm] = useState('');
  
  // フィルターの状態
  const [activeCategory, setActiveCategory] = useState('すべて');
  
  // 製品カテゴリー
  const categories = ['すべて', 'ファッション', 'テック', '本', '雑貨', 'コスメ'];

  // ダミーの商品データ
  const products = [
    {
      id: 1,
      name: 'SNS限定Tシャツ',
      category: 'ファッション',
      price: 2500,
      rating: 4.5,
      reviewCount: 120,
      image: 'https://picsum.photos/id/20/200/200',
      description: 'SNSユーザー限定デザインのTシャツです。着心地の良い素材を使用。 #限定品 #Tシャツ'
    },
    {
      id: 2,
      name: 'ワイヤレスイヤホン',
      category: 'テック',
      price: 12800,
      rating: 4.8,
      reviewCount: 350,
      image: 'https://picsum.photos/id/21/200/200',
      description: '高音質のワイヤレスイヤホン。ノイズキャンセリング機能付き。 #オーディオ #テック'
    },
    {
      id: 3,
      name: 'トートバッグ',
      category: 'ファッション',
      price: 3600,
      rating: 4.2,
      reviewCount: 89,
      image: 'https://picsum.photos/id/22/200/200',
      description: '丈夫な素材で作られたトートバッグ。日常使いにぴったり。 #バッグ #ファッション'
    },
    {
      id: 4,
      name: 'プログラミング入門書',
      category: '本',
      price: 2800,
      rating: 4.7,
      reviewCount: 215,
      image: 'https://picsum.photos/id/24/200/200',
      description: '初心者向けのプログラミング解説本。基礎から丁寧に解説。 #プログラミング #本'
    },
    {
      id: 5,
      name: 'デスクオーガナイザー',
      category: '雑貨',
      price: 1900,
      rating: 4.0,
      reviewCount: 67,
      image: 'https://picsum.photos/id/26/200/200',
      description: 'デスク周りを整理するのに便利なオーガナイザー。 #デスク用品 #整理整頓'
    },
    {
      id: 6,
      name: 'スキンケアセット',
      category: 'コスメ',
      price: 5400,
      rating: 4.6,
      reviewCount: 178,
      image: 'https://picsum.photos/id/28/200/200',
      description: '自然由来成分を使用したスキンケアセット。敏感肌の方にもおすすめ。 #スキンケア #コスメ'
    }
  ];

  // フィルターと検索で商品をフィルタリング
  const filteredProducts = products.filter(product => {
    const matchesCategory = activeCategory === 'すべて' || product.category === activeCategory;
    const matchesSearch = product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         product.description.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  // 評価を星で表示する関数
  const renderRatingStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;
    
    for (let i = 0; i < 5; i++) {
      if (i < fullStars) {
        stars.push(<BsStarFill key={i} className="shop__star shop__starFilled" />);
      } else if (i === fullStars && hasHalfStar) {
        stars.push(<BsStarHalf key={i} className="shop__star shop__starHalf" />);
      } else {
        stars.push(<BsStar key={i} className="shop__star" />);
      }
    }
    
    return stars;
  };

  // 検索処理
  const handleSearch = (e) => {
    e.preventDefault();
    // 実際には検索APIを呼び出すなどの処理を行う
    
  };

  // ハッシュタグクリック時のハンドラ
  const handleHashtagClick = (hashtag, event) => {
    event.stopPropagation(); // イベントバブリングを停止
    // ハッシュタグの#を除いて検索クエリに使用
    const tag = hashtag.substring(1);
    navigate(`/explore?hashtag=${tag}`);
  };

  // テキスト内のハッシュタグにスタイルを適用しクリック可能にする
  const formatText = (text) => {
    if (!text) return '';
    
    // ハッシュタグをハイライト（日本語を含むハッシュタグに対応）
    const parts = text.split(/(#[\w一-龯ぁ-んァ-ヶー]+)/g);
    
    return (
      <>
        {parts.map((part, index) => {
          if (part.startsWith('#')) {
            return (
              <span 
                key={index} 
                className="shop__hashtag"
                onClick={(e) => handleHashtagClick(part, e)}
              >
                {part}
              </span>
            );
          }
          return part;
        })}
      </>
    );
  };

  return (
    <div className="shop">
      <div className="shop__header">
        <h2>ショップ</h2>
        <div className="shop__cartIcon">
          <AiOutlineShoppingCart />
          <span className="shop__cartCount">0</span>
        </div>
      </div>

      <div className="shop__search">
        <form onSubmit={handleSearch} className="shop__searchForm">
          <AiOutlineSearch className="shop__searchIcon" />
          <input
            type="text"
            placeholder="商品を検索"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="shop__searchInput"
          />
          <button type="submit" className="shop__searchButton">検索</button>
        </form>
      </div>

      <div className="shop__filters">
        <div className="shop__filterLabel">
          <BsFilter /> カテゴリー:
        </div>
        <div className="shop__categories">
          {categories.map(category => (
            <button
              key={category}
              className={`shop__category ${activeCategory === category ? 'active' : ''}`}
              onClick={() => setActiveCategory(category)}
            >
              {category}
            </button>
          ))}
        </div>
      </div>

      {filteredProducts.length === 0 ? (
        <div className="shop__noResults">
          <p>該当する商品がありません</p>
        </div>
      ) : (
        <div className="shop__products">
          {filteredProducts.map(product => (
            <div key={product.id} className="shop__productCard">
              <div className="shop__productImageContainer">
                <img src={product.image} alt={product.name} className="shop__productImage" />
              </div>
              <div className="shop__productInfo">
                <h3 className="shop__productName">{product.name}</h3>
                <p className="shop__productCategory">{product.category}</p>
                <div className="shop__productRating">
                  <div className="shop__stars">
                    {renderRatingStars(product.rating)}
                  </div>
                  <span className="shop__reviewCount">({product.reviewCount})</span>
                </div>
                <p className="shop__productDescription">{formatText(product.description)}</p>
                <div className="shop__productBottom">
                  <div className="shop__productPrice">¥{product.price.toLocaleString()}</div>
                  <button className="shop__addToCartButton">カートに追加</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Shop; 